export const HTTP_403_FORBIDDEN = 403;
